<div class="container-fluid ml-n2">
  <div>
    <div class="list-detail-top mt-2">
      <div>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" v-on:click="openPrintModal">
          {{ $t('message.button_vehicle_dtc_print_modal') }}
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" v-on:click="openNoteModal">
          {{ $t('message.button_vehicle_dtc_note_modal') }}
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" v-on:click="switchChainDtc()">
          {{ $t(getChainDtcButtonLabel()) }}
        </b-button>
        <b-button v-if="testModeVisible" class="ml-2 mt-2" variant="primary" size="sm" v-on:click="dtcTestDataExport">
          Export DTC Data
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
          {{ $t('message.file_export') }}
        </b-button>
      </div>
      <div>
        <b-button :class="['ml-2 mt-2', checkButtonClass]" variant="primary" size="sm" v-on:click="updateDTC">
          {{ $t('message.button_vehicle_dtc_gain_again') }}
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" v-on:click="deleteDTC">
          {{ $t('message.button_vehicle_dtc_remove') }}
        </b-button>
      </div>
    </div>
  </div>

  <cstm-table useSort hasTabs rowSelect initSortDir="asc" :items="dtcListItems" :columns="dtcSystemTableColumns"
    class="mt-2 ml-2" type="simple" @rowClicked="clickRow" @rowButtonClicked="clickFFD" currentSortkey="status" useStripeStyle>
    <template v-slot:rowButton="{ row }">
      <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
      <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
    </template>
  </cstm-table>

  <!-- FFD 一覧画面 -->
  <b-modal v-model="modalFfd" size="huge" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <!-- FFDタイトルの設定 -->
    <template v-slot:header>
      <div class="text-center w-100">
        {{ ffdTitle }}
      </div>
    </template>

    <ffd-modal v-if="modalFfd" :ffdTableProp="ffdSystemTable" :systemProp="selectedSystem" :ffdSystem="ffdSystem"
      :ffdDescription="ffdDescription" :dataName="testModeMeasuredDataName" :destinationAPI="destinationAPI"
      :projectId="vehicleInfo.vehicle.project.id" :measureId="vehicleInfo.vehicle.project.all_dtc.measure_id"
      @updateLoading="processing = $event" ref="ffd_modal">
      <template v-slot:didTestBtn>
        <b-button v-if="testModeVisible" class="clear-button" variant="primary" size="sm" @click="didTestDataExport()">
          Export DID Data
        </b-button> 
      </template>
    </ffd-modal>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" @click="modalFfd=false" class="ml-2 mr-2">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- 帳票印刷 -->
  <b-modal v-model="modalFormPrint" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking 
    @show="resetModalPrint" @hidden="resetModalPrint" no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_print_modal') }}
      </div>
    </template>

    <print-modal v-if="modalFormPrint" ref="print_modal" :userInfoProp="printUserInfo"
      :vehicleVinProp="vehicleInfo.vehicle.vin.vin" :vehicleVinTypeProp="vehicleInfo.vehicle.vin.type" :allDtcTableProp="allDtcSystems" />

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" @click="modalFormPrint=false" class="ml-2 mr-2 mt-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="opensSettingMileage()" class="ml-2 mr-2 mt-2">
          {{ $t("printFormat.14") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="startPrint()" class="ml-2 mr-2 mt-2" :disabled="isPrintFormatButtonDisable">
          {{ $t('message.button_vehicle_dtc_print') }}
        </b-button>
      </div>
    </template>
  </b-modal>
  <!-- マイレージ設定ダイアログ -->
  <b-modal v-model="modalSettingMileageForm" header-bg-variant="secondary" header-text-variant="light"
    @show="resetMileageModal" @hidden="resetMileageModal" no-close-on-backdrop no-close-on-esc centered no-stacking>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('printFormat.14') }}
      </div>
    </template>
    <b-form-group label-for="name-input" :state="isAlert.data.valid">
      <b-form-input id="name-input" v-model="inputMileage" :state="isAlert.data.valid" maxlength="6" autocomplete="off"></b-form-input>
      <b-form-invalid-feedback>{{ $t(isAlert.data.msg) }}</b-form-invalid-feedback>
    </b-form-group>
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" @click="modalSettingMileageForm=false" class="mx-2 mt-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="settingMileageOk()" class="mx-2 mt-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- メモ画面 -->
  <b-modal v-model="modalMemo" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_note_modal') }}
      </div>
    </template>

    <memo-Page v-if="modalMemo" ref="memo" :projectId="vehicleInfo.vehicle.project.id"
      :measureId="vehicleInfo.vehicle.project.all_dtc.measure_id"  @closeNoteModal="closeNoteModal"
      :modalLoading="isMemoDialogLoading" @update-loading="isMemoDialogLoading = $event" />

    <template v-slot:footer>
      <button type="button" :disabled="isMemoDialogLoading" v-on:click="memoClear()"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">{{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="outline-primary" @click="modalMemo=false" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="primary" @click="memoSave()" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- 車両情報取得中のダイアログ -->
  <b-modal v-model="modalVehicle" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_label_execution') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-2 mb-2">
        <custom-Progress :value="progress" useResource :message="phaseMessage" />
      </div>
    </template>
  </b-modal>

  <!-- DTC削除のダイアログ -->
  <b-modal v-model="modalDelete" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_remove') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-2 mb-2">
        <custom-Progress :value="progress" :message="deletePhase" />
      </div>
    </template>
  </b-modal>

  <!-- CGW/C-ECU通信無し警告画面 -->
  <b-modal v-model="modalAlertCgwCecuNotCommunicated" size="lg" header-bg-variant="warning" header-text-variant="light"
    no-stacking no-close-on-backdrop centered no-close-on-esc>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.common_title_warning') }}
      </div>
    </template>

    <template v-slot:default>
      <label v-html="$t('message.message_no_connection_to_cgw_c_ecu')" class="text-center w-100 modal-message" style="font-weight: bold;"></label>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" class="ml-2 mr-2" @click="closeCGwNotConnectModal()">
          {{ $t('message.common_button_cancel')}}
        </b-button>
        <b-button size="sm" variant="primary" @click="restartConnectionToVehicle()" class="ml-2 mr-2">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>